"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ticker = void 0;
var event_emitter_1 = require("./event-emitter");
var three_1 = require("three");
var Ticker = /** @class */ (function (_super) {
    __extends(Ticker, _super);
    function Ticker() {
        var _this = _super.call(this) || this;
        _this.clock = new three_1.Clock();
        window.requestAnimationFrame(function () {
            _this.tick();
        });
        return _this;
    }
    Ticker.prototype.tick = function () {
        var _this = this;
        this.trigger('tick', [this.clock]);
        window.requestAnimationFrame(function () {
            _this.tick();
        });
    };
    return Ticker;
}(event_emitter_1.EventEmitter));
exports.Ticker = Ticker;
